var GridPreferencePanelsValue;

(function (GridPreferencePanelsValue) {
  GridPreferencePanelsValue["filters"] = "filters";
  GridPreferencePanelsValue["columns"] = "columns";
})(GridPreferencePanelsValue || (GridPreferencePanelsValue = {}));

export { GridPreferencePanelsValue };